module.exports = __webpack_public_path__ + "img/badge-list-thumb-061.cafec36e.png";